exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".table td[data-v-1a395578]{padding:.1rem;vertical-align:middle}.table th[data-v-1a395578]{padding:.5rem;vertical-align:middle}.sub-modal-content[data-v-1a395578]{background-color:#f0f8ff;border:2px solid #007bff;box-shadow:0 0 20px rgba(0,123,255,.4);border-radius:8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-1a395578","scoped":true,"sourceMap":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./App/Components/Job/JobAddSpareUsedList.vue
// module id = 898
// module chunks = 0